import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ServiceLevelAgreementModalComponent} from './service-level-agreement-modal';

export const ServiceLevelAgreementModalModule: string = ng
  .module('service-level-agreement-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('serviceLevelAgreementModal', ServiceLevelAgreementModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/service-level-agreement-modal/service-level-agreement-modal.module.ts